<form [formGroup]="passwordForm" class="password-form" data-testid="change-password-form">
    <div>
        <form-label [for]="'password'" [label]="subtitle(1101)"></form-label>
        <form-password-input [inputControl]="oldPasswordControl"
                             [id]="'password'"
                             [placeholder]="subtitle(1344)">
        </form-password-input>
        <form-label [for]="'new-password'" [label]="subtitle(1100)"></form-label>
        <form-password-input [inputControl]="newPasswordControl"
                             [id]="'new-password'"
                             [placeholder]="subtitle(1100)">
        </form-password-input>
        <form-label [for]="'confirm-password'" [label]="subtitle(1340)"></form-label>
        <form-password-input [inputControl]="confirmedPasswordControl"
                             [id]="'confirm-password'"
                             [showPasswordMismatch]="passwordForm.errors?.['passwordMismatch']"
                             [placeholder]="subtitle(1340)">
        </form-password-input>
    </div>
    <form-action-buttons>
        <form-button [subtitle]="subtitle(71)"
                     [btnType]="'cancel'"
                     (click)="closeForm()">
        </form-button>
        <form-button [subtitle]="subtitle(1255)"
                     [btnType]="'confirm'"
                     (click)="changePassword()">
        </form-button>
    </form-action-buttons>
</form>
